import React, { useState } from 'react';

export default function PlacementWelcomeModal({ isOpen, onClose }) {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleClose = () => {
    if (dontShowAgain) {
      localStorage.setItem('hidePlacementWelcome', 'true');
    }
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-surface rounded-lg shadow-lg max-w-md w-full p-6 border border-outline">
        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mb-4 mx-auto">
          <span className="material-symbols-outlined text-primary text-headline-lg">celebration</span>
        </div>
        
        <h2 className="text-headline-md text-on-surface text-center mb-3">Welcome to Your Network</h2>
        
        <p className="text-body-md text-on-surface/80 mb-4 text-center">
          Your account has been approved! You'll be positioned in the genealogy tree as your network grows. 
          This is where you'll track your referrals and see your team structure.
        </p>

        <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 mb-5">
          <p className="text-body-sm text-on-surface/70">
            <strong>What's next?</strong> Explore your dashboard, invite friends, and watch your network grow!
          </p>
        </div>

        <div className="flex items-center gap-3 mb-5">
          <input
            type="checkbox"
            id="dontShowAgain"
            checked={dontShowAgain}
            onChange={(e) => setDontShowAgain(e.target.checked)}
            className="w-4 h-4 cursor-pointer"
          />
          <label htmlFor="dontShowAgain" className="text-body-sm text-on-surface/70 cursor-pointer">
            Don't show this again
          </label>
        </div>

        <button
          onClick={handleClose}
          className="w-full bg-primary text-on-primary font-medium py-2 rounded-lg hover:opacity-90 transition-opacity"
        >
          Got it!
        </button>
      </div>
    </div>
  );
}
